import { usePontosItinerarioStore } from "../../stores/usePontosItinerarioStore";

const EMPTY = [];

export function usePontos(codigo) {

    return usePontosItinerarioStore(state => {

        const key = String(codigo || '').trim();

        return state.pontos[key] ?? EMPTY;

    });

}